import { useState } from "react";
import { ConfigProvider, Tabs } from "antd";
import { ExpenseType } from "@/types/expenseType";
import ExpenseDrafts from "./components/ExpenseDrafts";
import ExpenseHistory from "./components/ExpenseHistory";

interface ExpenseTabsProps {
  expenseTypes: ExpenseType[];
}

const ExpenseTabs = ({ expenseTypes }: ExpenseTabsProps) => {
  const [activeTabKey, setActiveTabKey] = useState<string>("drafts");

  const onTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  const tabItems = [
    {
      key: "drafts",
      label: "Draft",
      children: <ExpenseDrafts expenseTypes={expenseTypes} />,
    },
    {
      key: "history",
      label: "History",
      children: <ExpenseHistory />,
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            colorBorderSecondary: "transparent",
          },
        },
      }}
    >
      <Tabs items={tabItems} activeKey={activeTabKey} onChange={onTabChange} />
    </ConfigProvider>
  );
};

export default ExpenseTabs;
